import React from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

export default function ContextMenu({
  anchorPosition,
  open,
  onClose,
  onRename,
  onDelete,
  onCopy,
  onPaste,
  onCreateCategory,
  onCreateArticle,
  targetNode
}) {
  const isFolder = targetNode?.type === 'folder';

  return (
    <Menu
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { minWidth: 200 },
      }}
    >
      {isFolder && (
        <MenuItem onClick={onCreateCategory}>
          <ListItemIcon><CreateNewFolderIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Skapa ny kategori</ListItemText>
        </MenuItem>
      )}
      {isFolder && (
        <MenuItem onClick={onCreateArticle}>
          <ListItemIcon><DescriptionOutlinedIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Skapa ny artikel</ListItemText>
        </MenuItem>
      )}
      <MenuItem onClick={onRename}>
        <ListItemIcon><DriveFileRenameOutlineIcon fontSize="small" /></ListItemIcon>
        <ListItemText>Byt namn</ListItemText>
      </MenuItem>
      <MenuItem onClick={onDelete}>
        <ListItemIcon><DeleteOutlineIcon fontSize="small" /></ListItemIcon>
        <ListItemText>Radera</ListItemText>
      </MenuItem>
      <MenuItem onClick={onCopy}>
        <ListItemIcon><ContentCopyIcon fontSize="small" /></ListItemIcon>
        <ListItemText>Kopiera</ListItemText>
      </MenuItem>
      <MenuItem onClick={onPaste}>
        <ListItemIcon><ContentPasteIcon fontSize="small" /></ListItemIcon>
        <ListItemText>Klistra in</ListItemText>
      </MenuItem>
    </Menu>
  );
}
